module.exports = __webpack_public_path__ + "static/img/personnel-icon.372600f5.svg";